import React, { useState, useEffect } from 'react'
import Layouts from '../Layouts'
import { Radio, message } from 'antd';
import { getCurrentUser } from '../../utils/auth';
import { FiUser, FiMail, FiPhone, FiCheckCircle } from 'react-icons/fi';

const Myprofile = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [gender, setGender] = useState(0); // 1 = Male, 2 = Female
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [userId, setUserId] = useState('');

    useEffect(() => {
        const user = getCurrentUser();
        if (user) {
            setFirstName(user.firstName || '');
            setLastName(user.lastName || '');
            if (user.gender) {
                const g = user.gender.toLowerCase();
                if (g === 'male' || g === 'm') setGender(1);
                else if (g === 'female' || g === 'f') setGender(2);
            }
            setEmail(user.email || '');
            setMobile(user.mobile || '');
            setUserId(user.userId || user.id || 'N/A');
        }
    }, []);

    const onChange = (e) => {
        setGender(e.target.value);
    };

    const handleSave = () => {
        message.success("Profile details saved successfully!");
    };

    // Extract initials for the avatar
    const initials = `${firstName.charAt(0) || ''}${lastName.charAt(0) || ''}`.toUpperCase() || 'U';

    return (
        <Layouts>
            <div className="min-h-screen bg-gray-50/50 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto bg-white rounded-3xl border border-gray-100 shadow-[0_15px_40px_rgba(0,0,0,0.03)] overflow-hidden">
                    {/* Header Banner */}
                    <div className="bg-gradient-to-r from-[#8C6913] via-[#A17A17] to-[#B88E28] h-40 relative">
                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.15),transparent)] pointer-events-none" />
                        
                        {/* Avatar Overlap */}
                        <div className="absolute -bottom-10 left-8 flex items-end gap-5">
                            <div className="w-24 h-24 rounded-[28px] bg-white border-4 border-white shadow-lg flex items-center justify-center text-3xl font-bold text-[#A17A17] select-none">
                                {initials}
                            </div>
                            <div className="mb-14">
                                <h2 className="text-xl font-bold  text-white leading-none">
                                    {firstName} {lastName}
                                </h2>
                                <span className="inline-block mt-2 px-2.5 py-0.5 bg-white/20 text-white font-medium text-xs rounded-full uppercase tracking-wider">
                                    Customer ID: {userId}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Form Section */}
                    <div className="p-8 pt-16">
                        <div className="flex justify-between items-center pb-6 border-b border-gray-100 mb-8">
                            <div>
                                <h3 className="text-xl font-bold text-gray-800">Account Settings</h3>
                                <p className="text-sm text-gray-400 mt-1">Manage and update your personal information.</p>
                            </div>
                            <button 
                                onClick={handleSave}
                                className="px-5 py-2.5 bg-gradient-to-r from-[#A17A17] to-[#B88E28] hover:from-[#8C6913] hover:to-[#A17A17] text-white font-bold text-sm rounded-xl shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer active:scale-98"
                            >
                                Save Changes
                            </button>
                        </div>

                        {/* Input Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                            
                            {/* First Name */}
                            <div className="flex flex-col gap-2">
                                <label className="text-xs uppercase font-bold text-gray-400 tracking-wider flex items-center gap-1.5">
                                    <FiUser className="text-amber-700" /> First Name
                                </label>
                                <input
                                    type="text"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    className="w-full border border-gray-200/80 p-3 rounded-xl bg-white focus:outline-none focus:border-[#A17A17] focus:ring-1 focus:ring-[#A17A17] text-sm text-gray-700 font-medium transition-all"
                                    placeholder="First name"
                                />
                            </div>

                            {/* Last Name */}
                            <div className="flex flex-col gap-2">
                                <label className="text-xs uppercase font-bold text-gray-400 tracking-wider flex items-center gap-1.5">
                                    <FiUser className="text-amber-700" /> Last Name
                                </label>
                                <input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    className="w-full border border-gray-200/80 p-3 rounded-xl bg-white focus:outline-none focus:border-[#A17A17] focus:ring-1 focus:ring-[#A17A17] text-sm text-gray-700 font-medium transition-all"
                                    placeholder="Last name"
                                />
                            </div>

                            {/* Gender */}
                            <div className="flex flex-col gap-2">
                                <label className="text-xs uppercase font-bold text-gray-400 tracking-wider">
                                    Gender
                                </label>
                                <div className="border border-gray-200/80 p-3 rounded-xl bg-white h-11 flex items-center">
                                    <Radio.Group onChange={onChange} value={gender} className="flex gap-6">
                                        <Radio className="text-sm font-semibold text-gray-600" value={1}>Male</Radio>
                                        <Radio className="text-sm font-semibold text-gray-600" value={2}>Female</Radio>
                                    </Radio.Group>
                                </div>
                            </div>

                            {/* Email Address */}
                            <div className="flex flex-col gap-2">
                                <label className="text-xs uppercase font-bold text-gray-400 tracking-wider flex items-center gap-1.5">
                                    <FiMail className="text-amber-700" /> Email Address
                                </label>
                                <div className="relative">
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full border border-gray-200/80 p-3 pr-10 rounded-xl bg-white focus:outline-none focus:border-[#A17A17] focus:ring-1 focus:ring-[#A17A17] text-sm text-gray-700 font-medium transition-all"
                                        placeholder="yourname@gmail.com"
                                    />
                                    {email && (
                                        <FiCheckCircle className="absolute right-3.5 top-1/2 -translate-y-1/2 text-green-500 text-base" title="Verified email" />
                                    )}
                                </div>
                            </div>

                            {/* Mobile Number */}
                            <div className="flex flex-col gap-2">
                                <label className="text-xs uppercase font-bold text-gray-400 tracking-wider flex items-center gap-1.5">
                                    <FiPhone className="text-amber-700" /> Mobile Number
                                </label>
                                <div className="relative">
                                    <input
                                        type="tel"
                                        value={mobile}
                                        onChange={(e) => setMobile(e.target.value)}
                                        className="w-full border border-gray-200/80 p-3 pr-10 rounded-xl bg-white focus:outline-none focus:border-[#A17A17] focus:ring-1 focus:ring-[#A17A17] text-sm text-gray-700 font-medium transition-all"
                                        placeholder="Phone number"
                                    />
                                    {mobile && (
                                        <FiCheckCircle className="absolute right-3.5 top-1/2 -translate-y-1/2 text-green-500 text-base" title="Verified mobile" />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layouts>
    )
}

export default Myprofile
